import script from "./ProductBrands.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBrands.vue?vue&type=script&setup=true&lang=js"

import "./ProductBrands.vue?vue&type=style&index=0&id=4d8991b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8991b4"]])

export default __exports__